import { BookingWohooIcon, NotificationAlertIcon, SocCompleteIcon } from "../Icons";
import React, { FC } from "react";

import { AlertCustom } from "../../styles/styledComponents";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Snackbar } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

interface SnackbarGenericProps {
  message: string;
  open: boolean;
  onClose: () => void;
  severity?: "error" | "warning" | "info" | "success";
  alertType?: string; // Custom alert type
  customIcon?: string;
  customMessage?:JSX.Element | null;
}


const iconMapping = {
  error: <ErrorOutlineRoundedIcon />,
  warning: <WarningAmberRoundedIcon />,
  info: <InfoOutlinedIcon />,
  success: <DoneOutlinedIcon />,
};

// can add custom icons here
export const customIconMapping: {[key: string]: any} = {
  default: <DoneOutlinedIcon />,
  successCelebrateIcon: <BookingWohooIcon/>,
  notificationAlertIcon: <NotificationAlertIcon/>,
  info: <InfoOutlinedIcon />,
  paymentUpdateIcon: <div className="bg-turquoise-2 rounded-full p-2">
    <SocCompleteIcon height={19} width={19} />
  </div>,
};

const SnackbarGeneric: FC<SnackbarGenericProps> = ({ message, open, onClose, severity = "error", alertType,
  customIcon, customMessage }) => {
  const mappedIcon = customIcon ? customIconMapping[customIcon] : iconMapping[severity];

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ zIndex: 9999 }}
    >
      <AlertCustom
        severity={severity}
        className={alertType ? `MuiAlert-standard${alertType}` : ""} // Add custom class
        icon={mappedIcon}
      >
        {customMessage ? customMessage : message}
      </AlertCustom>
    </Snackbar>
  );
};

export default SnackbarGeneric;
